import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';

import { ROUTE_404 } from '@/common/constants';
import PageLoader from '@/ebat/components/blocks/PageLoader/PageLoader';

import NoCart from './NoCart/NoCart';
import Scanbat from './Scanbat';
import useScanbatContainer from './useScanbat.container';

const ScanbatContainer = () => {
  const { t } = useTranslation();

  const {
    cart,
    company,
    isDisabled,
    isError,
    isSuccess,
    refetchCart,
    warehouse,
  } = useScanbatContainer();

  if (isError) {
    return <Redirect to={ROUTE_404} />;
  }

  if (isDisabled.loading && !cart) {
    return <PageLoader className="scanbat-page" />;
  }

  if (warehouse && !cart) {
    return (
      <>
        <Helmet>
          <title>
            {`${t('ebat:entities:scanbat.cart.title')} - ${t(
              'ebat:messages:scanbat.title',
            )}`}
          </title>
        </Helmet>
        <main className="main scanbat-page">
          <NoCart
            disabled={isDisabled.disabled}
            isLoading={isDisabled.loading}
            warehouse={warehouse}
          />
        </main>
      </>
    );
  }

  if (isSuccess) {
    return (
      <>
        <Helmet>
          <title>
            {`${t('ebat:entities:scanbat.cart.title')} - ${t(
              'ebat:messages:scanbat.title',
            )}`}
          </title>
        </Helmet>
        <main className="main scanbat-page">
          <Scanbat
            cart={cart}
            company={company}
            disabled={isDisabled.disabled}
            isLoading={isDisabled.loading}
            refetchCart={refetchCart}
            warehouse={warehouse}
          />
        </main>
      </>
    );
  }

  return null;
};

ScanbatContainer.defaultProps = {};

ScanbatContainer.propTypes = {};

export default ScanbatContainer;
